var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5556 24.8889H16V21.3333H12.4444V17.7778H16V21.3333H19.5556M19.5556 10.6667H16V14.2222H19.5556V17.7778H16V14.2222H12.4444V10.6667H16V7.11111H12.4444V3.55556H16V7.11111H19.5556M28.4444 0H3.55556C1.58222 0 0 1.58222 0 3.55556V28.4444C0 29.3874 0.374602 30.2918 1.0414 30.9586C1.70819 31.6254 2.61256 32 3.55556 32H28.4444C29.3874 32 30.2918 31.6254 30.9586 30.9586C31.6254 30.2918 32 29.3874 32 28.4444V3.55556C32 1.58222 30.4 0 28.4444 0Z",
    fill: "#0B1F33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.8244ec85df88982d20e47893b49240f9.svg";
export { ForwardRef as ReactComponent };